import AddIcon from '@material-ui/icons/Add'
import { motion } from 'framer-motion'
import PropTypes from 'prop-types'

import { S05 } from '../../../styles/typography'
import { ItemEl } from '../elements'

const Item = ({ question, answer, isActive, toggleActive }) => {
  return (
    <ItemEl isActive={isActive} onClick={toggleActive}>
      <motion.p className='question'>
        <span>{question}</span>
        <AddIcon />
      </motion.p>

      <S05
        animate={{
          height: isActive ? 'auto' : 0,
        }}
        as={motion.p}
        className='answer'
        initial={{ height: 0 }}
        transition={{ damping: 20, stiffness: 100, type: 'spring' }}
      >
        {answer.map((ans, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={`ans-${i}`}>{ans}</span>
        ))}
      </S05>
    </ItemEl>
  )
}

export default Item

Item.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  isActive: PropTypes.bool.isRequired,
  question: PropTypes.string.isRequired,
  toggleActive: PropTypes.func.isRequired,
}
